Object.defineProperty(exports, "__esModule", {
  value: true
});

function ExistsQuery(field) {
  return {
    exists: {
      field: field
    }
  };
}

exports.ExistsQuery = ExistsQuery;